import styled from 'styled-components';
import { Colors, maxMedia } from 'modules/utils';
import { Form } from 'formik';
import { Sizes } from 'modules/utils/cp3/styles';
import { StellarTheme } from '@lavu-pos/stellar';
import { colors as stellarColors } from '@lavu-pos/stellar/dist/themes';

// up to 600px
const muiBreakpoint = 'xs';

// Footer
export const StyledFooter = styled.div`
	text-align: center;
	opacity: 0.6;
	grid-area: login-footer;
	padding: 0 0 20px 0;
	${StellarTheme.breakpoints.down(muiBreakpoint)} {
		padding: 20px;
	}

	.login-page-footer-text {
		font-family: 'Open Sans', sans-serif;
		color: ${stellarColors['white']};
		font-size: 12px;
		${StellarTheme.breakpoints.down(muiBreakpoint)} {
			color: ${stellarColors['purple-solid']};
		}
	}
`;

// Map Section

export const StyledMapSection = styled.div`
	margin-left: 248px;
	overflow: hidden;
`;

export const StyledMapImage = styled.img`
	height: 100%;
`;

// SiderBar
export const SideBarContainer = styled.div`
	width: 248px;
	background-image: linear-gradient(
		166deg,
		${Colors.DARK_BLUE},
		${Colors.DARK_PURPLE}
	);
	float: left;
	color: ${Colors.WHITE};
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const SideBarLogoWrapper = styled.div`
	align-self: center;
`;

// Mobile Login page
export const MobileStyles = styled.div`
	height: 100%;
	display: grid;
	grid-template-rows: 1fr 1fr 1fr;
	grid-template-columns: 1fr 10fr 1fr;
	grid-template-areas:
		'. logo-image .'
		'. login-form .'
		'. login-footer .';
`;

// Common Form Styles
export const StyledForm = styled(Form)`
	margin: auto;
	padding: 0px 20px;
	width: 100%;
	place-self: center;
	grid-area: login-form;

	${StellarTheme.breakpoints.down(muiBreakpoint)} {
		margin: 0;

		.login-form-input {
			background-color: ${stellarColors['gray-medium']};
		}
		.login-form-input[value=''] + label {
			font-weight: 100;
			font-size: 15px;
			top: 9px;
			left: 9px;
		}
		.login-form-input + label {
			font-weight: 100;
		}
	}

	button {
		font-family: 'Open Sans', sans-serif;
		letter-spacing: -0.02em;
	}

	input:-webkit-autofill + label {
		display: none;
	}

	${maxMedia.PHONE`
		// iOS automatically zooms in when the input's font size is lower than 16px.
		// This causes other UI issues because it doesn't zoom out all the times.
		// See: https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone 

		input {
			font-size: 16px;
		}
	`};
	.login-form-text {
		font-family: 'Open Sans', sans-serif;
		color: ${stellarColors['white']};
		font-weight: 600;
		font-size: 12px;
		${StellarTheme.breakpoints.down(muiBreakpoint)} {
			color: ${stellarColors['purple-medium']};
		}
	}

	.login-form-title {
		font-size: 24px;
		${StellarTheme.breakpoints.down(muiBreakpoint)} {
			font-size: 26px;
			margin-bottom: 35px;

			@media only screen and (max-width: ${Sizes.IPHONE_SE}px) {
				margin-bottom: 10px;
				font-size: 22px;
			}
		}
	}

	.login-form-forgot-password {
		font-weight: 400;
		margin-top: 12px;
		font-size: 12px;

		${StellarTheme.breakpoints.down(muiBreakpoint)} {
			font-size: 14px;
			color: ${stellarColors['blue-medium']};
		}
	}

	.login-form-welcome-message {
		font-size: 17px;
		margin-bottom: 15px;
		letter-spacing: -0.26px;
		color: ${stellarColors['purple-medium']};

		@media only screen and (max-width: ${Sizes.IPHONE_SE}px) {
			margin-bottom: 2px;
			font-size: 14px;
		}
	}

	.password-reset-form-text {
		font-family: 'Open Sans', sans-serif;
		color: ${stellarColors['white']};
		${StellarTheme.breakpoints.down(muiBreakpoint)} {
			color: ${stellarColors['purple-solid']};
		}
	}

	.login-form-error,
	.password-reset-success,
	.password-reset-error {
		color: ${stellarColors['white']};
	}

	.password-reset-form-title {
		font-weight: 300;
		font-size: 24px;
	}

	.password-reset-message {
		font-size: 10px;
		font-weight: 100;
		${StellarTheme.breakpoints.down(muiBreakpoint)} {
			font-size: 12px;
		}
	}

	.password-reset-error,
	.password-reset-success,
	.password-reset-link {
		font-family: 'Open Sans', sans-serif;
		font-size: 10px;
		font-weight: 300;
		${StellarTheme.breakpoints.down(muiBreakpoint)} {
			font-size: 12px;
		}
	}
`;

export const StyledFormMessage = styled.p`
	background-color: ${props => props.bgcolor || Colors.DANGER};
	border: solid 1px ${props => props.bdcolor || Colors.DANGER};
	border-radius: 4px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin: 10px 0;
	min-height: 35px;
	padding: 6px;
	text-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
`;

// Login Form Styles

export const LinkWrapper = styled.div`
	text-align: right;
`;

// Password Rest Styles

export const StyledLinkWrapper = styled.div`
	text-align: center;
	padding-top: 15px;
`;

export const StyledFormHeader = styled.div`
	padding-bottom: 5px;
`;

export const StyledInputWrapper = styled.div`
	margin: 20px auto;
`;
